<template>
  <div class="body flex-col">
    <!-- news -->
    <div class="bottom flex-row">
      <div class="news flex-col">
        <div
          class="box flex-row"
          v-for="item in dataList"
          :key="item.id"
          @click="toBlogDetail(item)"
        >
          <img :src="item.imageUrl" alt="" class="img" v-if="item.imageUrl" />
          <div class="contentRight">
            <div class="title" v-html="item.title"></div>
            <div class="text">{{ item.description }}</div>
            <div class="time">{{ item.publishTime }}</div>
          </div>
        </div>
        <div class="loadingMoreButton justify-center">
          <div class="button" @click="loadMore()">{{ this.loadText }}</div>
        </div>
      </div>
      <div class="hot flex-col">
        <div class="hot-head flex-row">
         <img src="@/assets/images/digitalIcon2.png" alt="" class="hot-img" />
          <div class="hot-title">{{$t("热点资讯")}}</div>
          <!-- <div class="hot-change" @click="changeBanner2()">更多 ></div> -->
        </div>
        
        <div class="hot-body flex-col">
          <div
            class="hot-box flex-row"
            v-for="(item,index) in hotList"
            :key="item.id"
            @click="toBlogDetail(item)"
          >
            <div :class="[index > 2 ? 'number':'number1']">{{index +1}} </div>
            <div class="title" v-html="item.title"></div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import { getRecommends, getArticles } from "@/config/api.js";

export default {
  data() {
    return {
      loadText: this.$t("加载更多"),
      topPage: 1,
      bannerPage: 1,
      page: 1,
      bannerlist: [],
      bannerList2: [],
       hotList: [],
      topList: [],
      dataList: [],

      blogList: [],
      initialValue: 6,
      timestamp: new Date().getTime(),
      type: "",
      dialogVisible: false,
      isShowMore: false,
    };
  },
  created() {
    this.type = this.$route.query.type;

    this.getRecommendArticles();
    this.requestgetArticles();
  },
  methods: {
     // 推荐快讯
   async getRecommendArticles() {
      const param = { type: 0, pc: 16 };
      getRecommends(param).then((res) => {
        console.log("getRecommendArticles in other===", res.data.data);
        if (res.data.data.length>0) {
          this.hotList = res.data.data;
        }
      });
    },
    changeTop() {
      this.topPage++;
      this.requestgetArticleRecommend2();
    },

    //全部文章
    requestgetArticles() {
      const param = { pn: this.page, pc: 10, type: this.type};
      getArticles(param).then((res) => {
        console.log("requestgetArticles in other page ====", res.data);
        if (res.data) {
          for (let i = 0; i < res.data.data.length; i++) {
            this.dataList.push(res.data.data[i]);
          }
          if (res.data.data.length==0) {
            this.loadText = "暂无更多";
          }
        }
      });
    },

    //   var param = {
    //     page: this.page,
    //     size: 10,
    //     status: "1",
    //     categoryId: this.type,
    //   };
    //   getArticles(param).then((res) => {
    //     console.log("requestgetArticles===", res.data);
    //     if (res.data) {
    //       for (let i = 0; i < res.data.data.length; i++) {
    //         this.dataList.push(res.data.data[i]);
    //       }
    //       if (res.data.data.length == 0) {
    //         this.loadText = this.$t("暂无更多");
    //       } else {
    //         this.loadText = this.$t("加载更多");
    //       }
    //     }
    //   });
    // },
    loadMore() {
      this.page++;
      this.requestgetArticles();
    },

    toBlogDetail(item) {
      this.blogDetailKey = item.id;
      this.$router.push({
        path: "/detail",
        query: {
          id: item.id,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.body {
  height: 100%;
  width: 100%;
  // background: #232323;
  padding: 6% 10%;
  color: #1f1f22;
  .top {
    padding: 0% 0% 0% 0%;
  }
  .hot {
    width: 27%;
    // background: pink;
    height: 800px;
    margin: 0 0px 0 3%;

    .hot-head {
      width: 100%;
      height: 30px;
      line-height: 30px;
      font-size: 17px;
      .hot-img {
        padding: 0px 10px 0 0px;
        width: 12%;
        height: 100%;
        object-fit: contain;
      }
      .hot-title {
        margin-left: 10px;
        width: 70%;
        height: 100%;
        color: #1f1f22;
        // background: purple;
      }
      .hot-change {
        width: 50px;
        height: 100%;
        font-size: 15px;
        text-align: right;
      }
    }

    .hot-body {
      margin-top: 20px;
      height: 80%;
      //background: yellow;
      overflow: hidden;
      border: solid 0.08em #eeeeee;
      border-radius: 10px;
      padding: 10px;
    }
    .hot-box {
      padding: 7px 10px;
      height: auto;
      line-height: 20px;

         .number {
        width: 25px;
        height: 20px;
        text-align: center;
        color: white;
        background: rgb(177, 177, 177);
        border-radius: 0 10px 0 10px;
      }
      .number1 {
        width: 25px;
        height: 20px;
        text-align: center;
        color: white;
        background: rgb(230, 63, 21);
        border-radius: 0 10px 0 10px;
      }
       .title {
        font-size: 13px;
        height: 20px;
        padding: 0px 15px;
        width: 95%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: pointer;
      }
      .dot {
        font-size: 18px;
        font-weight: 600;
        line-height: 20px;
        text-align: center;
        color: #1f1f22;
        width: 5px;
      }
      .hot-time {
        margin: 0px 20px 0px 20px;
        line-height: 40px;
        color: #a0a0a9;
        border-bottom: 1px solid #f5f5f5;
      }
    }
  }
  .bottom {
    margin-top: 20px;
  }
  .news {
    height: auto;
    width: 70%;
    // background: blueviolet;
    .loadingMoreButton {
      height: 60px;
      text-align: center;
      width: 100%;

      .button {
        width: 140px;
        height: 30px;
        line-height: 30px;
        border-radius: 15px;
        background: gainsboro;
      }
    }
    .box {
      height: 130px;
      width: 100%;
      //  background: yellow;
      margin-bottom: 15px;
      padding: 10px 0;
    }
    .img {
      height: 100%;
      width: 20%;
      background: gainsboro;
      justify-content: center;
      object-fit: cover;
      border-radius: 10px;
      margin: 0 20px 0 0;
    }
    .contentRight {
      height: 100%;
      width: 75%;
      padding: 0 0 0 0px;
      // background: purple;
      .title {
        line-height: 30px;
        height: 30px;
        font-size: 15px;
        font-weight: 550;
        width: 100%;
        color: #1f1f22;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: pointer;
      }
      .text {
        width: 100%;
        line-height: 20px;
        height: 40px;
        font-size: 12px;
        color: #767680;

        word-break: break-all;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .time {
        height: 20px;
        width: 100%;
        margin-top: 20px;
        line-height: 20px;
        // background: blue;
        color: #767680;
        font-size: 12px;
      }
    }
  }
}
body * {
  box-sizing: border-box;
  flex-shrink: 0;
}
body {
  font-family: PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma,
    Arial, PingFang SC-Light, Microsoft YaHei;
}
input {
  background-color: transparent;
  border: 0;
}
button {
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  outline: none;
  background-color: transparent;
}

button:active {
  opacity: 0.6;
}
.van-nav-bar__left:active,
.van-nav-bar__right:active {
  opacity: 1;
}
[class*="van-"]::after {
  border-bottom: 0;
}
.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.justify-start {
  display: flex;
  justify-content: flex-start;
}
.justify-center {
  display: flex;
  justify-content: center;
}

.justify-end {
  display: flex;
  justify-content: flex-end;
}
.justify-evenly {
  display: flex;
  justify-content: space-evenly;
}
.justify-around {
  display: flex;
  justify-content: space-around;
}
.justify-between {
  display: flex;
  justify-content: space-between;
}
.align-start {
  display: flex;
  align-items: flex-start;
}
.align-center {
  display: flex;
  align-items: center;
}
.align-end {
  display: flex;
  align-items: flex-end;
}
</style>